import { EmailInputForm } from './EmailInputForm';

export default EmailInputForm;
